import styled from 'styled-components'

export const Heading1 = styled.h1({
  margin: '4rem 0 2rem 0',
  fontSize: '2.4rem',
  textAlign: 'center',
  textTransform: 'uppercase',
})
